import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.refresh()
  }

  refresh(event) {
    const type = this.element.querySelector("[name='deliverable[delivery_type]']")
    const incoterm = this.element.querySelector("[name='deliverable[incoterms]']")
    if (type) {
      this.element.querySelectorAll("[data-delivery-reference-type]").forEach(hint => {
        hint.hidden = hint.dataset.deliveryReferenceType !== type.value
      })
      const returns = this.element.querySelector("[data-delivery-section='returns']")
      const typeChanged = event?.target === type
      if (returns) {
        returns.hidden = type.value === "normal"
        if (returns.hidden && typeChanged) {
          returns.querySelectorAll("input").forEach(input => { input.value = "" })
        }
      }
      const status = this.element.querySelector("[name='deliverable[status]']")
      if (status) {
        Array.from(status.options).forEach(option => {
          const allowed = option.dataset.deliveryTypes.split(" ").includes(type.value)
          option.hidden = !allowed
          option.disabled = !allowed
        })
        if (typeChanged && status.selectedOptions[0]?.disabled) status.value = "pending"
      }
    }
    if (incoterm) this.element.querySelectorAll("[data-delivery-reference-incoterm]").forEach(hint => {
      hint.hidden = hint.dataset.deliveryReferenceIncoterm !== incoterm.value
    })
  }
}
